// auth.js
const TOKEN_KEY = 'tutor_management_token';

export const getToken = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  console.log('Retrieved token from storage:', !!token);
  return token;
};

export const setToken = (token) => {
  console.log('Setting token in storage');
  localStorage.setItem(TOKEN_KEY, token);
};

export const removeToken = () => {
  console.log('Removing token from storage');
  localStorage.removeItem(TOKEN_KEY);
};

export const isAuthenticated = () => {
  const token = getToken();
  return !!token; // Jednoduchá kontrola - token existuje
};

// Funkcia na vymazanie všetkých autentifikačných údajov
export const clearAuth = () => {
  removeToken();
  sessionStorage.removeItem('lectorName');
  sessionStorage.removeItem('cachedPackages');
  sessionStorage.removeItem('cacheTimestamp');
};